// extracted by mini-css-extract-plugin
export default {"container":"empty_container__DqNPy","title":"empty_title__+VbGb","desc":"empty_desc__eH7xr"};